import { RangePipe } from './range.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShuttleInformationPipe } from './shuttle-information/shuttle-information.pipe';
import { ShuttleInformationService } from './shuttle-information/shuttle-information.service';
import { ReservationStatusPipe } from './reservation-status.pipe';
import { SpinModule } from '../../shared/spin/spin.module';
import { MileageTypePipe } from './mileage-type.pipe';
import { FilterByPipe } from './filter-by.pipe';
import { VehicleTypePipe } from './vehicle-type.pipe';
import { ReservationService } from './reservation/reservation.service';
import { DebugPopulateService } from './reservation/debug-populate.service';
import { AccertifyService } from './accertify.service';
import { PriceDisplayService } from '../shared/price-display.service';
import { PriceDisplayLabelComponent } from './price-display-label/price-display-label.component'
import { InsuranceService } from './insurance/insurance.service';
import { QuoteService } from './insurance/quote.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    RangePipe,
    ShuttleInformationPipe,
    ReservationStatusPipe,
    MileageTypePipe,
    FilterByPipe,
    VehicleTypePipe,
    PriceDisplayLabelComponent
  ],
  exports: [
    RangePipe,
    ShuttleInformationPipe,
    SpinModule,
    ReservationStatusPipe,
    MileageTypePipe,
    FilterByPipe,
    VehicleTypePipe,
    PriceDisplayLabelComponent
  ],
  providers: [
    ShuttleInformationService,
    ReservationService,
    DebugPopulateService,
    AccertifyService,
    PriceDisplayService,
    InsuranceService,
    QuoteService
  ]
})
export class SharedCarModule { }
